import * as React from "react";
import { ViewMe, useMyIdentities } from "@njoy/controller";
import { Form, Field, Formik, FormikHelpers as FormikActions } from "formik";
import { Form as AntForm, Select } from "antd";
import { personalDetailSchema } from "@njoy/common";

import { TemplateSub } from "../../../../components/layouts/TemplateSub";
import { SelectField } from "../../../shared/SelectField";
import { InputField } from "../../../shared/InputField";
import NewButton from "../../../../components/uiMerge/newButton";
import { TextAreaField } from "../../../shared/TextAreaField";
import { DateField } from "../../../shared/DateField";
import { MultiSelect } from "src/modules/shared/multipleSelectField";
import PageLoader from "src/modules/shared/PageLoader";

const FormItem = AntForm.Item;
const { Option } = Select;

export interface UserFormValues {
  avatarUrl: string | null;
  username: string;
  communityId: string[];
  dob: string;
  address: string;
  gender: string;
}

interface Props {
  initialValues?: UserFormValues;
  submit: (
    data: UserFormValues,
    actions: FormikActions<UserFormValues>
  ) => Promise<void>;
}

export const defaultCustomerFormValues = {
  username: "",
  communityId: [],
  dob: "",
  address: "",
  gender: "",
};

const selectGender = [
  { key: "1", label: "Male" },
  { key: "2", label: "Female" },
];

class C extends React.PureComponent<any & Props> {
  render() {
    const { submit, initialValues } = this.props;

    return (
      <ViewMe>
        {(data) => {
          const { myIdentities, loading } = useMyIdentities({
            offset: 0,
            limit: 5,
          });

          if (!data.match || loading) {
            return <PageLoader />;
          }

          return (
            <TemplateSub page={`Personal Details`}>
              <Formik<UserFormValues>
                validationSchema={personalDetailSchema}
                validateOnChange={true}
                validateOnBlur={true}
                initialValues={initialValues}
                onSubmit={submit}
              >
                {({ isSubmitting, values }) => (
                  <div className="flex flex-col min-h-[98vh] w-full  px-[1rem]">
                    <React.Fragment>
                      <div className="mt-8 mb-2 w-full flex-1 flex flex-col">
                        <Form className="flex flex-col flex-1">
                          <div className="w-full flex-1 flex flex-col">
                            <div className="flex-1">
                              <div className="flex-1">
                                <label
                                  className="text-[#CECECF] opacity-90"
                                  htmlFor="firstname"
                                >
                                  First Name
                                </label>
                                <Field
                                  name="firstname"
                                  placeholder="Firstname"
                                  component={InputField}
                                  useNumberComponent={false}
                                  value={initialValues.firstname}
                                  disabled={true}
                                />

                                <label
                                  className="text-[#CECECF] opacity-90"
                                  htmlFor="lastname"
                                >
                                  Last Name
                                </label>
                                <Field
                                  name="lastname"
                                  placeholder="Last name"
                                  type="text"
                                  component={InputField}
                                  useNumberComponent={false}
                                  value={initialValues.lastname}
                                  disabled={true}
                                />

                                <label
                                  className="text-[#CECECF] opacity-90"
                                  htmlFor="username"
                                >
                                  Njoy Username
                                </label>
                                <Field
                                  name="username"
                                  placeholder="Username"
                                  component={InputField}
                                  useNumberComponent={false}
                                />

                                <label
                                  className="text-[#CECECF]"
                                  htmlFor="communityId"
                                >
                                  Your Communities
                                </label>

                                <Field name="communityId">
                                  {() => {
                                    const options = (myIdentities || []).map(
                                      (c: any) => ({
                                        label: c.community.alias,
                                        value: c.community.id,
                                      })
                                    );

                                    const allCommunityIds = options.map(
                                      (o) => o.value
                                    );
                                    return (
                                      <MultiSelect
                                        options={options}
                                        value={allCommunityIds}
                                        disabled={true}
                                      />
                                    );
                                  }}
                                </Field>

                                <p className="text-[16px] mt-8 text-white !mb-[16px]">
                                  Additional Information
                                </p>

                                <label className="text-[#CECECF]" htmlFor="dob">
                                  Date of Birth
                                </label>
                                <Field
                                  disabled={initialValues.dob ? true : false}
                                  name="dob"
                                  placeholder="dd/mm/yyyy"
                                  component={DateField}
                                  className={`h-[3rem] w-full custom-date-picker !rounded-lg !border-none appearance-none px-4 py-3 text-base !bg-[#1E1E1E] backdrop-blur-sm placeholder:text-white/40 focus:outline-none focus:ring-2 shadow-lg transition-all 
                                    duration-200 disabled:bg-gray-100 
                                    disabled:cursor-not-allowed  ${initialValues.dob ? " text-[#8e8e8e]" : "text-[white]"}`}
                                    
                                />

                                <label
                                  className="text-[#CECECF] opacity-90"
                                  htmlFor="Residential Address"
                                >
                                  Residential Address
                                </label>
                                <Field
                                  name="address"
                                  placeholder="Enter Your Address"
                                  component={TextAreaField}
                                  className="personal-detail-text-area"
                                  rows={3}
                                />

                                <label
                                  className="text-[#CECECF]"
                                  htmlFor="communityId"
                                >
                                  Gender
                                </label>
                                <Field name="gender" component={SelectField}>
                                  <Option value="" disabled>
                                    Select gender
                                  </Option>
                                  {selectGender.map((c) => (
                                    <Option key={c.key} value={c.label}>
                                      {c.label}
                                    </Option>
                                  ))}
                                </Field>

                                <div className="mt-auto pt-3">
                                  <FormItem>
                                    <NewButton
                                      type="submit"
                                      fullWidth
                                      variant="primary"
                                      loading={isSubmitting}
                                    >
                                      Save Changes
                                    </NewButton>
                                  </FormItem>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Form>
                      </div>
                    </React.Fragment>
                  </div>
                )}
              </Formik>
            </TemplateSub>
          );
        }}
      </ViewMe>
    );
  }
}

export const PersonalDetailView = C;
